// extracted by mini-css-extract-plugin
module.exports = {"selected-group-by":"SelectedGroupBy_selected-group-by__2bmkI","remove-button":"SelectedGroupBy_remove-button__1jJbq"};